import type { MailingAddress } from './types';

export const EMPTY_ADDRESS: MailingAddress = {
  line1: '',
  line2: '',
  city: '',
  state: '',
  postalCode: '',
};

/**
 * The first part of a mailing address still owed, in the words the fields
 * use, or null when it is whole. The register endpoint asks the same thing.
 */
export function addressMissing(a: MailingAddress): string | null {
  if (!a.line1.trim()) return 'Street address';
  if (!a.city.trim()) return 'City';
  if (!a.state.trim()) return 'State';
  if (!a.postalCode.trim()) return 'ZIP code';
  return null;
}
